import { Text } from "@artprov/design-system";
import PropTypes from "prop-types";
import React from "react";

const MatchingCard = ({ matchingData }) => {
    return (
        <div className="bg-tertiary-100 border border-tertiary-95 rounded py-6 px-4">
            {/* Título */}
            <Text variant="subtitle1" className="text-primary-10">
                Detalle de Matching
            </Text>

            {/* Línea divisoria */}
            <div className="h-px bg-tertiary-80 my-4" />

            {/* Desagregado por campo */}
            <div className="grid grid-cols-2 gap-x-4 gap-y-3 min-h-7">
                {matchingData?.campos
                    ?.filter((campo) => campo.campo !== null)
                    ?.map((campo) => (
                        <React.Fragment key={campo.campo}>
                            <Text variant="body2" className="text-tertiary-60">
                                {campo.campo}
                            </Text>
                            <Text variant="body2" className="text-tertiary-10 font-semibold">
                                {campo?.porcentaje > 0 ? `${campo?.porcentaje}%` : ""}
                            </Text>
                        </React.Fragment>
                    ))}
            </div>
        </div>
    );
};

MatchingCard.propTypes = {
    matchingData: PropTypes.shape({
        porcentajeTotal: PropTypes.number,
        campos: PropTypes.arrayOf(
            PropTypes.shape({
                campo: PropTypes.string,
                porcentaje: PropTypes.number,
            })
        ),
    }),
};

export default MatchingCard;
